import { map, Observable } from 'rxjs';
import { CompanyModel } from '../models/iam-dtos';
import { UserResponseModel } from '../services/iamapi/iamapi.services';
import { TransformUtilities } from './utilities.transform';

export class GetUserAccessedCompaniesTransforms {
  static transformOutput(response$: Observable<UserResponseModel>): Observable<CompanyModel[]> {
    return response$.pipe(
      map((userData: UserResponseModel) =>
        TransformUtilities.ExtractUserAccessedCompanies(userData),
      ),
    );
  }
}
